import {
  Breadcrumb,
  BreadcrumbProps,
  MaxWidthContent,
  MaxWidthContentProps,
} from "@endya-conformite/ui-kit";
import Logo from "@endya-conformite/ui-kit/src/assets/logo.png";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { BreadcrumbProvider } from "@src/context/BreadcrumbContext";
import { UserMenu } from "../UserMenu/UserMenu";
import styles from "./ConnectedPageTemplate.module.scss";

export type ConnectedPageTemplateProps<T> = {
  children: ReactNode;
  breadcrumb?: BreadcrumbProps<T>;
  isAxe?: boolean;
  maxWidth?: MaxWidthContentProps["size"];
};

export function ConnectedPageTemplate<T>({
  children,
  breadcrumb,
  isAxe = false,
  maxWidth = "xlarge",
}: ConnectedPageTemplateProps<T>) {
  const navigate = useNavigate();

  const handleLogoClick = () => navigate("/");

  const content =
    isAxe && breadcrumb ? (
      <BreadcrumbProvider breadcrumb={breadcrumb}>
        {children}
      </BreadcrumbProvider>
    ) : (
      <MaxWidthContent size={maxWidth} className={styles.content}>
        {children}
      </MaxWidthContent>
    );

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.main}>
        <div className={styles.header}>
          <div className={styles.logoContainer}>
            <button
              type="button"
              className={styles.logoButton}
              onClick={handleLogoClick}
              aria-label="Retour à l'accueil"
            >
              <img src={Logo} alt="logo" className={styles.logo} />
            </button>
            <div className={styles.separator} />
            <div className={styles.title}>
              Gestion <br />
              <b>des contrôles</b>
            </div>
          </div>
          <UserMenu />
        </div>
        {breadcrumb && !isAxe && (
          <div className={styles.breadcrumbContainer}>
            <Breadcrumb variant="bald" {...breadcrumb} />
          </div>
        )}
      </div>
      {content}
    </div>
  );
}
